import { IPageHandler } from './pageHandler';
import { GtmSender } from '../../marketing/GtmSender';
import { LandingPopupKind } from '../../constants/LandingPopupKind';
import { SystemEvents } from '../../constants/gameEvents';
import { RegFbEmailPopup } from '../../popups/regFbEmail';
import { StretchPopup } from '../../popups/stretchPopup';
import { PopupManager } from '../../popups/popupManager';
import { calcBackground, onReadyCalcBack } from '../../general/calcIndexBackAndPopup';
import { LandingType } from '../../constants/LandingTypes';
import { Registration4StepsPopup } from '../../popups/registration4steps';
import { WebEmailGatherActions } from '../../constants/EmailGatherActions';
import { RegistrationNicknamesPopup } from '../../popups/registrationNicknamesPopup';
import { Webgl2020ResourcesLoader } from '../../gameClient/webgl/webgl2020ResourcesLoader';
import { UserFingerprint } from '../../general/modules/userFingerpint/UserFingerprint';
import { ClientJS } from 'clientjs';

export class CommonLpHandler implements IPageHandler {
    public run(): void {
        console.log('common handler is run');
        const isInteractiveMapLandingType = window.app.config.landings.landingType !== LandingType.INTERACTIVE_MAP &&
                window.app.config.landings.landingType !== LandingType.INTERACTIVE_ONE_MAP;

        if (isInteractiveMapLandingType && (location.href.includes('article') === false)) {
            $(window).on('resize', calcBackground);
            onReadyCalcBack();
        }

        PopupManager.init();
        this.setupFormHandler();
        this.setEventsTracking();
        StretchPopup.stretch();
        $(window).on('resize', StretchPopup.stretch);
        try {
            if (window.app.config.landings.landingType !== LandingType.INSTANT_REG) {
                Webgl2020ResourcesLoader.preloadWebglBuild();
            }
        } catch (error) {
            window.Sentry.captureException(error);
            console.error(error);
        }
        this.openAuthFormByConfig();
        new UserFingerprint(new ClientJS());
    }

    private openAuthFormByConfig() {
        if (!window.app.config.landings.enableAuthStateForm) {
            return;
        }
        const formId = 'login';
        PopupManager.openSingle(formId);
    }

    private setupFormHandler() {
        switch (window.app.config.landings.popupKind) {
            case LandingPopupKind.FOUR_STEP_SITE_REG:
                Registration4StepsPopup.initPopups();
                return;
            case LandingPopupKind.NICKNAME_SITE_REG:
                RegistrationNicknamesPopup.initPopups();
                return;
            case LandingPopupKind.FB_EMAIL_SITE_REG:
                RegFbEmailPopup.setup();
        }
    }

    private setEventsTracking() {
        GtmSender.fireLanding(SystemEvents.LANDING);

        $('#registration input[name=email], #registration2 input[name=email]')
            .one(
                'keypress',
                function handleLpEmailKeypress() {
                    $('#registration input[name=email], #registration2 input[name=email]')
                        .one(
                            'change',
                            function handleLpEmailChange() {
                                GtmSender.fireLanding(SystemEvents.ENTER_EMAIL);
                            }
                        );
                }
            );

        $('#registration input[name=password], #registration2 input[name=password]')
            .one(
                'keypress',
                function handleLpPasswordKeypress() {
                    $('#registration input[name=password], #registration2 input[name=password]')
                        .one(
                            'change',
                            function handleLpPasswordChane() {
                                GtmSender.fireLanding(SystemEvents.ENTER_PASSWORD);
                            }
                        );
                }
            );

        $('#login,#registration').find('.icon')
            .one(
                'click',
                function handleLpSocialIconClick() {
                    GtmSender.fireLanding(SystemEvents.CLICK_SOCIAL_ICON);
                }
            );

        $('#registration .js-terms_agree,#registration2 .js-terms_agree').one('click', () => {
            GtmSender.fireLanding(SystemEvents.CHECK_POLICY);
        });

        $('.registration-fb-email__step-1').find('button')
            .one(
                'click',
                function handleEmailGatherLoginClick() {
                    const eventName = $(this).text()
                        .toUpperCase()
                        .trim();
                    const sysEvent = WebEmailGatherActions.get(eventName);
                    if (sysEvent) {
                        GtmSender.fireLanding(sysEvent);
                    }
                }
            );

        const consentSelectors = [
            '#registration #receive_consent',
            '#registration2 .registration_dialog_terms__agree',
            '#registration #receive_consent0',
            '#registration #receive_consent1'
        ].join();

        $(consentSelectors).one('click', () => {
            GtmSender.fireLanding(SystemEvents.CHECK_CONSENT);
        });

        $(document)
            .one(
                'click',
                '#registration:not(.step1) [type="submit"],#registration2:not(.step1) [type="submit"]',
                () => {
                    GtmSender.fireLanding(SystemEvents.SUBMIT);
                }
            );
    }
}
